import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';
import DemandChangeStartEndEdit from '../polling/pollingTopicEdit/DemandChangeStartEndEdit';

export type SelectDemandChangeStartEndDialogProps = {
    isOpen: boolean;
    onOK: (data: any) => void;
    onCancel: () => void;
    mainId: string;
};

export const SelectDemandChangeStartEndDialog = (props: SelectDemandChangeStartEndDialogProps) => {
    const { isOpen, onOK, onCancel, mainId } = props;
    const [open, setOpen] = React.useState(isOpen);

    // Cancelボタンイベント
    const handleCancel = () => {
        setOpen(false);
        onCancel();
    };

    const handleUpdate = (data: any) => {
        setOpen(false);
        onOK(data);
    };

    return (
        <div>
            <Dialog open={open} maxWidth={"md"} fullWidth>
                <DialogTitle>デマンド開始終了変更</DialogTitle>
                <DialogContent sx={{ pb: 1.5 }}>
                    <DemandChangeStartEndEdit onCancel={handleCancel} onOK={(data) => handleUpdate(data)} mainId={mainId}></DemandChangeStartEndEdit>
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default SelectDemandChangeStartEndDialog;